import { onBeforeMount, ref } from 'vue';
import { useStore } from 'vuex';
import { SampleDataService } from '@/services/sample-data-service';
import { isEven } from '@/services/common/helpers';
const service = new SampleDataService();
const emptyFieldArray = [];
const emptyDataArray = [];
export default {
    name: 'DataSample',
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    setup(props) {
        const store = useStore();
        const fieldNames = ref(emptyFieldArray);
        const sampleData = ref(emptyDataArray);
        const loading = ref(true);
        onBeforeMount(async () => {
            const response = await service.Get(props.id);
            loading.value = false;
            if (response.ok) {
                const r = response.val;
                fieldNames.value = r.fieldNames;
                const attributeArray = [];
                r.data.forEach((feature) => {
                    attributeArray.push(feature.properties);
                });
                sampleData.value = attributeArray;
            }
        });
        return { fieldNames, sampleData, loading, isEven };
    },
};
